
export const NAN = 'nan';
export const NA = 'N/A';

export const SIZE = {
    EXTRA_LARGE: 'xl',
    LARGE: 'lg',
    MEDIUM: 'md',
    SMALL: 'sm',
    EXTRA_SMALL: 'xs',
};

export const NOTIFICATION_STATUS = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    INFO: 'info'
};

export const CATEGORY = {
    STRUCTURAL: 'STRUCTURAL',
    TACTICAL: 'TACTICAL'
};

export const CHART_NAME = {
    CHART_STRUCTURAL: CATEGORY.STRUCTURAL,
    CHART_TACTICAL: CATEGORY.TACTICAL,
    CHART_NUMBER_OF_O_AND_D_CHANGED_FARE: 'Number of O&Ds Changed Fare',
    CHART_AVERAGE_FARE_CHANGE: 'AVERAGE FARE CHANGE',
    CHART_COMPETITIVE_CHANGE_FARE: 'CHART COMPETITIVE CHANGE FARE'
};

export const DASHBOARD_TOP_TABS_VALUE = {
    RECOMMENDATION: 'recommendation',
    COMPETITION: 'competition',
};

export const COMPETITION_STATUS_TABS = {
    COMPETITOR_CHANGES_FARES: 'Fares'
};

export const CRITERIA_MARKET_KEY = 'market';

export const PERCENTAGE_ABSOLUTE_TABS_VALUE = {
    PERCENTAGE: 'percentage',
    ABSOLUTE: 'absolute',
    RELATIVE: 'relative'
};

export const DEFAULT_DASHBOARD_HISTORY_DAYS = 30;
export const DASHBOARD_HISTORY_DAYS_CONFIG_KEY = 'FO_DASHBOARD_APPROVAL_DISPLAY_HISTORY';

export const IS_FARE_CHANGES_SUMMARY_FROM_ATHENA_KEY = 'IS_FARE_CHANGES_SUMMARY_FROM_ATHENA';

export const URL_SAVE_CRITERIA_CONTEXT_ID = 'fo-dashboard';

export const COMMA = ',';

export const FO_HOST_CARRIER_KEY = 'FO_HOST_CARRIER';
